import React from "react"
import Soon from "../../../UI/Soon"

const ToDo = () => {

    return (
        <Soon />
    )
}

export default ToDo